import { Subject } from 'rxjs/Subject';
import type { ResourcesCacheUpdateRequest } from '../../common/types.tsx';

// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default new Subject<ResourcesCacheUpdateRequest>();
